<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
        <p class="modal-title">{{data?.nzTitle}}</p>
    </div>

    <div class="flex justify-end">
        <button class="button primary-button mr-2" (click)="onLinkMultipleRawMaterials()">
            Añadir materias primas en bloque
        </button>
        <button class="button primary-button" (click)="addPackaging()">
            Añadir formato
        </button>
    </div>
</div>
<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (packagings && packagings.length > 0) {
        <nz-table #basicTable [nzData]="packagings" class="m-0 p-0" nzSize="small" [nzLoading]="isLoading"
            nzTableLayout="auto" [nzBordered]="true" [nzFrontPagination]="false" [nzShowPagination]="false"
            [nzScroll]="{ y: (tableHeight-50 || 0) + 'px', x:'240px' }" [nzVirtualItemSize]="41"
            [nzVirtualMinBufferPx]="tableHeight" [nzVirtualMaxBufferPx]="tableHeight" [nzVirtualForTrackBy]="trackByIndex">
            <thead>
                <tr>
                    <th nzWidth="50px">Nº</th>
                    <th>Número de lote</th>
                    <th>Tipo de formato</th>
                    <th>Cantidad</th>
                    <th>Materias primas asignadas</th>
                    <th nzWidth="200px">Acciones</th>
                </tr>
            </thead>
            <tbody>
                <ng-template nz-virtual-scroll let-packaging let-idx="index">
                    <tr>
                        <td>{{ idx+1 }}</td>
                        <td>{{ packaging.batchNumber }}</td>
                        <td>{{ packaging.packagingType?.name || '' }}</td>
                        <td>
                            <nz-input-group [nzSuffix]="getDisplayUnit()">
                                <input onfocus="select()" nz-input [(ngModel)]="packagings[idx].quantity" type="number" />
                            </nz-input-group>
                            <!-- TODO: Uncomment this section if kg handling is introduced in the future. -->
                            <!--  @if (isKgProcess()) {
                                    <div class="mt-2">
                                        <nz-input-group nzSuffix="kg">
                                            <input onfocus="select()" nz-input [(ngModel)]="packagings[idx].axuliaryQuantity" type="number" placeholder="Cantidad en kg" />
                                        </nz-input-group>
                                    </div>
                                } -->
                        </td>
                        <td>{{ packaging.rawMaterials?.length || 0 }}</td>
                        <td>
                            <div class="flex align-middle justify-center">
                                <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                    [nzTooltipTitle]="'Ver y añadir materias primas'" nzTooltipPlacement="bottom" nz-tooltip
                                    (click)="onLinkRawMaterials(packaging)">
                                    <span nz-icon nzType="appstore-add"></span>
                                </button>
                                <nz-divider nzType="vertical"></nz-divider>
                                <button nz-button nzType="text" nzShape="circle" class="table-icon"
                                    [nzTooltipTitle]="'Eliminar formato'" nzTooltipPlacement="bottom" nz-tooltip
                                    (click)="removePackaging(packaging)">
                                    <span nz-icon nzType="delete"></span>
                                </button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </nz-table>
        }
        @else {
        <div class="w-full h-full content-center">
            <nz-empty></nz-empty>
        </div>
        }
    }
</div>

<div *nzModalFooter>
    <div class="flex justify-end">
        <button (click)="handleCancel()" class="button secondary-button mr-2">
            Cancelar
        </button>

        <button nz-button class="button primary-button" (click)="handleSave()" [nzLoading]="isSaving">
            Aceptar
        </button>
    </div>
</div>
